import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { ListsIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
export const TeamIcon = () => /*#__PURE__*/_jsx(IconCircle, {
  backgroundColor: "fill-surface-raised",
  borderWidth: "0",
  color: "fill-tertiary-alt",
  "data-test-id": "team-icon",
  icon: ListsIcon,
  size: "200"
});